import axios from 'axios';

export default class HttpServiceLogin {
    constructor(baseURL) {
        this.instance = axios.create({
            baseURL
        });

        this.instance.interceptors.request.use(async (config) => {
            config.headers['Access-Control-Allow-Origin'] = '*';
            config.headers['Access-Control-Allow-Methods'] = '*';
            config.headers['Access-Control-Allow-Headers'] = '*';
            config.headers['Access-Control-Allow-Credentials'] = '*';

            return config;
        });
    }
}
